import {cssClasses} from '../../common/helpers/browser/cssClasses';
import {tAsString} from '../../common/helpers/react/text/tAsString';
import {DialogController} from './DialogController';
import {ButtonConfig} from './ButtonConfig';

export namespace ModalButtons {
    export function CANCEL(dialogController: DialogController, secondary?: boolean): ButtonConfig {
        return {
            secondary: secondary !== undefined ? secondary : true,
            children: tAsString('CANCEL'),
            className: cssClasses(
                'qa-modal-cancel-button',
                'aat-autokey-escape-first'
            ),
            onClick: () => {
                dialogController.closeModal().andWeAreDone();
            }
        };
    }

    export function OK(dialogController: DialogController, secondary?: boolean): ButtonConfig {
        return {
            secondary: secondary !== undefined ? secondary : false,
            children: tAsString('OK'),
            className: cssClasses(
                'qa-modal-ok-button',
                'aat-autokey-escape-first'
            ),
            onClick: () => {
                dialogController.closeModal().andWeAreDone();
            }
        };
    }
}